import styles from "./MyTicketsScreen.style";

export default styles;
